module.exports = new __parcel__URL__("filter.76d6858b.svg").toString();